import { createFileRoute, redirect } from "@tanstack/react-router";
import { myWeddingsQuery } from "@bridewell/api-client";

/** Landing inside the app: open your wedding, or start one. */
export const Route = createFileRoute("/app/")({
  beforeLoad: async ({ context }) => {
    const mine = await context.queryClient.fetchQuery(myWeddingsQuery);
    if (mine.length === 0) throw redirect({ to: "/app/new" });
    const upcoming = mine.find((w) => new Date(w.weddingDate) >= new Date()) ?? mine[mine.length - 1]!;
    throw redirect({ to: "/app/w/$weddingId", params: { weddingId: upcoming.id } });
  },
});
